import {
  FaHtml5,
  FaCss3,
  FaJs,
  FaReact,
  FaGithub,
  FaNodeJs,
  FaPython,
  FaGitAlt,
  FaFigma,
  FaBootstrap,
  FaNpm,
  FaJava,
  FaPhp,
  FaLinux,
  FaAngular,
  FaDocker,
  FaWordpress,
} from "react-icons/fa";

import {
  SiExpress,
  SiTailwindcss,
  SiDart,
  SiFlutter,
  SiMysql,
  SiMongodb,
  SiPostgresql,
  SiC,
  SiCplusplus,
  SiTypescript,
  SiVite,
  SiAndroidstudio,
  SiIntellijidea,
  SiPostman,
  SiVercel,
  SiFirebase,
  SiFastapi,
  SiNextdotjs,
  SiGitlab,
  SiSqlite,
  SiSqlalchemy,
  SiGooglegemini,
  SiSocketdotio,
} from "react-icons/si";

import { DiVisualstudio } from "react-icons/di";

// Helper to keep the flat list for the Chatbot
export const skills = [
  { icon: FaAngular, name: "Angular" },
  { icon: FaReact, name: "React" },
  { icon: SiNextdotjs, name: "Next.js" },
  { icon: SiFlutter, name: "Flutter" },
  { icon: FaJs, name: "JavaScript" },
  { icon: FaHtml5, name: "HTML5" },
  { icon: FaCss3, name: "CSS3" },
  { icon: FaJava, name: "Java" },
  { icon: SiDart, name: "Dart" },
  { icon: FaNodeJs, name: "Node.js" },
  { icon: SiExpress, name: "Express.js" },
  { icon: SiFastapi, name: "FastAPI" },
  { icon: SiSocketdotio, name: "WebSockets" },
  { icon: SiMysql, name: "MySQL" },
  { icon: SiMongodb, name: "MongoDB" },
  { icon: SiPostgresql, name: "PostgreSQL" },
  { icon: SiSqlite, name: "SQLite" },
  { icon: SiSqlalchemy, name: "SQLAlchemy" },
  { icon: SiTailwindcss, name: "Tailwind CSS" },
  { icon: FaBootstrap, name: "Bootstrap" },
  { icon: FaPython, name: "Python" },
  { icon: FaPhp, name: "PHP" },
  { icon: SiC, name: "C" },
  { icon: SiCplusplus, name: "C++" },
  { icon: SiTypescript, name: "TypeScript" },
  { icon: SiGooglegemini, name: "Google Gemini" },
  { icon: FaGitAlt, name: "Git" },
  { icon: FaGithub, name: "GitHub" },
  { icon: SiGitlab, name: "GitLab" },
  { icon: FaLinux, name: "Linux" },
  { icon: FaFigma, name: "Figma" },
  { icon: FaNpm, name: "npm" },
  { icon: SiVite, name: "Vite" },
  { icon: SiAndroidstudio, name: "Android Studio" },
  { icon: DiVisualstudio, name: "VS Code" },
  { icon: SiIntellijidea, name: "IntelliJ IDEA" },
  { icon: SiPostman, name: "Postman" },
  { icon: SiVercel, name: "Vercel" },
  { icon: SiFirebase, name: "Firebase" },
  { icon: FaDocker, name: "Docker" },
  { icon: FaWordpress, name: "WordPress" },
];

// Categorized data for the interactive Spider Web visualization
export const skillCategories = [
  {
    id: "frontend",
    category: "Frontend Dev",
    skills: ["React", "Next.js", "Angular", "TypeScript", "Tailwind", "Bootstrap", "HTML5/CSS3", "Vite"],
    x: 50,
    y: 19, // Top
    color: "#FF9800",
  },
  {
    id: "mobile",
    category: "Mobile Dev",
    skills: ["Flutter", "Dart", "Android Studio"],
    x: 74,
    y: 30, // Top Right
    color: "#9C27B0",
  },
  {
    id: "backend",
    category: "Backend Dev",
    skills: ["Node.js", "Express", "FastAPI", "Python", "Java", "PHP", "C/C++"],
    x: 79,
    y: 58, // Right
    color: "#2196F3",
  },
  {
    id: "ai",
    category: "AI & Automation",
    skills: ["Gemini API", "LLM / Groq", "Web Scraping", "PyInstaller", "pytest"],
    x: 63,
    y: 81, // Bottom Right
    color: "#EC4899",
  },
  {
    id: "database",
    category: "Database",
    skills: ["MongoDB", "MySQL", "PostgreSQL", "SQLite", "SQLAlchemy", "Firebase"],
    x: 37,
    y: 81, // Bottom Left
    color: "#4CAF50",
  },
  {
    id: "tools",
    category: "DevOps & Tools",
    skills: ["Git", "GitHub", "GitLab", "Docker", "Linux", "Postman", "Vercel", "npm"],
    x: 21,
    y: 58, // Left
    color: "#FF5722",
  },
  {
    id: "cms",
    category: "CMS & Other",
    skills: ["WordPress", "IntelliJ", "VS Code"],
    x: 26,
    y: 30, // Top Left
    color: "#00BCD4",
  }
];
